module.exports = __webpack_public_path__ + "img/logo-brand-b2c.ea1b8a5.svg";